import Vue from 'vue'
import Vuex from 'vuex'
import home from './home/index'
import payments from './payments/index'
import transaction from './transaction/index'
import paymentType from './paymentType/index'
import login from './login/index'
import request from './request/index'
import quickLinks from './quickLinks/index'
import merchants from './merchants/index'
import loyaltyPointStatement from './loyaltyPointStatement/index'
import shopWithBrands from './shopWithBrands/index'
import dmi from './dmi/index'
import recharge from './recharge/index'
import postpaid from './postpaid/index'
import statement from './statement/index'
import eplNewDashboard from './eplNewDashboard/index'
import quickLinksNewDashboard from './quickLinksNewDashboard/index'
import signup from './signup/index'
Vue.use(Vuex)

const Store = new Vuex.Store({
  modules: {
    home,
    payments,
    transaction,
    paymentType,
    login,
    quickLinks,
    merchants,
    request,
    loyaltyPointStatement,
    shopWithBrands,
    dmi,
    recharge,
    postpaid,
    statement,
    eplNewDashboard,
    quickLinksNewDashboard,
    signup
  }
})

export default Store



// WEBPACK FOOTER //
// ./src/store/store.js